<!--
  Implementation
  -in template:
  <preview-pane :loaded="!loading">
    <template v-slot:header>
      //Your header
    </template>
    <template v-slot:panels>
      //Your panels
    </template>
    <template v-slot:actions>
      //Your actions
    </template>
  </preview-pane>
  -import:
  import PreviewPane from "@/views/layouts/PreviewPane.vue";
-->
<template>
  <!-- When on mobile wrap in dialog -->
  <slotted-dialog v-if="isPhoneBool"
    :title="title"
    :externaltrigger="dialogtrigger"
    :externalCloseTrigger="dialogclosetrigger">
    <template v-slot:content>
      <slot name="content">
        <job-status-alert :config="alertconfig"></job-status-alert>
        <v-expansion-panels v-model="panels"
          class="pa-6"
          multiple>
          <slot name="panels"></slot>
        </v-expansion-panels>
      </slot>
    </template>
    <template v-slot:buttons>
      <slot name="buttons" />
    </template>
  </slotted-dialog>
  <!-- When on anything else show normal -->
  <v-container v-else fluid class="pa-0 relative" style="height: inherit; overflow-y: auto;" :style="styleoverride">
    <v-progress-linear :indeterminate="!loaded" absolute style="z-index: 11;" height="2" v-if="!loaded">
    </v-progress-linear>

    <slot name="header">
      <preview-header :title="title" :loading="!loaded">
      </preview-header>
    </slot>
    <slot name="content">
      <job-status-alert :config="alertconfig"></job-status-alert>
      <v-expansion-panels v-model="panels" class="pa-6 pb-16" multiple>
        <slot name="panels"></slot>
      </v-expansion-panels>
    </slot>
    <slot name="actions"></slot>
  </v-container>
</template>
<script>
import PreviewHeader from "@/components/SingleUse/PreviewHeader.vue";
import SlottedDialog from "@/views/layouts/SlottedDialog.vue";
import JobStatusAlert from "@/components/Sections/JobStatusAlert.vue";
export default {
  name: "PreviewPane",
  props: ["title", "loaded", "styleoverride", "alertconfig"],
  components: { PreviewHeader, SlottedDialog, JobStatusAlert },
  data() {
    return {
      panels: [],
    };
  },
  mounted() {
    this.rememberPanels();
  },
  methods: {
    rememberPanels() {
      var stored = localStorage.getItem(this.$route.name + "panels");
      this.panels = stored ? JSON.parse(stored) : [];
    },
  },
  computed: {
    dialogtrigger() {
      return this.$store.state.triggerevents.previewTrigger;
    },
    dialogclosetrigger() {
      return this.$store.state.triggerevents.previewCloseTrigger;
    },
  },
  watch: {
    $route: function () {
      this.rememberPanels();
    },
    panels: function () {
      if (this.loaded) {
        localStorage.setItem(this.$route.name + "panels", JSON.stringify(this.panels));
      }
    },
  },
};
</script>
<style scoped>
.relative {
  position: relative;
}

.minitoolbar {
  position: sticky;
  top: 0px;
  z-index: 10;
  box-shadow: 0px 1px 5px var(--v-header-darken2) !important;
}

/*
.minitoolbar:after {
  content: "";
  background: -webkit-linear-gradient(
    left,
    rgba(255, 255, 255, 1) 0%,
    rgba(200, 200, 200, 1) 50%,
    rgba(255, 255, 255, 1) 100%
  );
  display: block;
  height: 2px;
  bottom: 0;
}*/
</style>